// PDF Page Designer Class
// The Definistion of our PDF Presenter is held in a JSON config file
// This class gives impel acces to the data and the common functions required of it


 export class PDFPages {
    constructor(json) {
        //console.log("constructor")
        try{
            this.json = json    // JSON.parse(json)
            return true
        }catch(err) { 
            console.log("Error in PDFPages constructor")
            console.log(err)
            return false}
    }
    static makeObject(json) {        
        if (!this.x) {
            this.x = new PDFPages(json);
        }
        return this.x;
    }

    getAllPages() {
        var pages = []
        for (const key in this.json){
            if(this.json.hasOwnProperty(key)){
                const page = (typeof this.json[key].page !== "undefined") ?this.json[key].page : ''
                if(typeof page !== "undefined" ) pages.push(this.json[key])
            }
        }
        return pages
    }

    getOnePage(key) {
        if(this.json === "undefined")
            return null
        const page = this.json['page'+key]
        if(typeof page !== "undedfined" ) return page
        else return null
    }

    getOnePageFields(key) {
        const page = this.getOnePage(key)
        if(typeof page === "undefined" ) return null
        const fields = page.fields
        if(typeof fields === "undefined") return null
        return fields
    }

    getOnePDFOutputFile(key) {
        const page = this.getOnePage(key)
        if(typeof page === "undefined" ) return null
        const file = page.page
        if(typeof file === "undefined") return null
        return file
    }

    fieldReport(field, title) {
        //console.log(`****** ${title} ******`)
        switch(typeof field) {
            case "undefined":
                //console.log("Field is undefined")
                break;
            case "function":
                //console.log("Field is a function")
                break;
            default: 
                //if(field === null) console.log("Field is null")
                //else console.log(field)
                break;
        }

        //console.log("*".repeat(title.length + 14) )
    }

    isAction(key,action) {
        const page = this.getOnePage(key)
        if(typeof page === "undefined") return null
        if(typeof page.action !== "undefined" && page.action.toLowerCase() === action.toLowerCase()) return true
        return false
    }
    isMailMerge(key) { return this.isAction(key,"mailmerge") }      // See if Page is a MailMerge File
    isTemplate(key) { return this.isAction(key,"templatepage") }    // See if Page is a Template File
    isCreateDataTables(key) { return this.isAction(key,"createdatatables") } // is a CreateDataTables
    isMergeImages(key) { return this.isAction(key,"mergeimages") }  // See if Page is an Image Merge
    hasFilter(key) { 
        const page = this.getOnePage(key)
        var ret
        if(page === null ) ret = false
        else if(typeof page.filter === "undefined") ret = false
        else ret = page.filter ? true : false
        return ret
    }
    hasTemplate(key) { 
        const page = this.getOnePage(key)
        var ret
        if(page === null ) ret = false
        else if(typeof page.template === "undefined") ret = false
        else ret = page.template ? true : false
        return ret
    }
    getFilter(key) {
        if(!this.hasFilter(key)) return null
        return this.getOnePage(key).filter
    }

    getTemplate(key) {
        if(!this.hasTemplate(key)) return null
        return this.getOnePage(key).template

    }

    getNumPages() {
        return this.json.num_slides
    }
}


